module.exports = __webpack_public_path__ + "static/media/withdraw_grey.264e3262.svg";